export default "__VITE_ASSET__B7a6fEQN__"